import React from 'react';
import useGetmahsulCategories from './hooks';
import {Link, useLocation} from 'react-router-dom';
import {toggleSideBar} from 'store/redux/sideBar';
import {useDispatch} from 'react-redux';
import DotsLoading from 'components/loadings/dotsLoading';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';

const SideBarMenu = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const isFarm = location.pathname.includes('farm');
  const {categorys, isLoading} = useGetmahsulCategories();
  return (
    <div
      className=" flex flex-col gap-6 overflow-y-auto max-h-[90vh] w-[300px] px-4"
      dir="ltr"
    >
      {isLoading ? (
        <DotsLoading />
      ) : (
        <>
          {categorys?.results.map((item, index) => (
            <Link
              onClick={() => {
                googleAnalyticsInstance.eventGoogleAnalytics({
                  category: `${
                    isFarm ? 'farm' : 'wholesaler'
                  }-choose-product-item`,
                  action: `کاربر ایتم ${item.title}  از لیست محصولات را انتخاب کرد`,
                });
                dispatch(toggleSideBar({isOpen: false}));
              }}
              to={`/${isFarm ? 'farm' : 'wholesaler'}/adds/${item.guid}`}
              className="flex flex-row-reverse font-medium items-center gap-4  my-1"
              key={index}
              state={{title: item.title}}
            >
              <span
                className={`${item.icon} !text-light-green-1 text-[20px] w-[20px]`}
              />
              <span className="text-gray-6 text-[14px]">{item.title}</span>
            </Link>
          ))}
        </>
      )}
    </div>
  );
};

export default SideBarMenu;
